import { Component, Input, forwardRef } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ld-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true
    }
  ]
})
export class SelectComponent {

  @Input()
  options: string[];

  @Input()
  name: string;

  @Input()
  displayName: string;

  @Input()
  selectControl: FormControl;

  showDropdown: boolean;
  selectedOption: string;
  selected: any;

  propagateChange = (_: any) => {};

  constructor() {
  }

  public writeValue(obj: any): void {
    if (!!obj) {
      this.selected = obj;
      this.propagateChange(this.selected);
    }
  }

  public registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {

  }

  public setDisabledState(isDisabled: boolean): void {

  }

  activateDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  select(index) {
    this.selected = this.options[index];
    if (!!this.selectControl) {
      this.selectControl.setValue(this.selected);
    }

    this.writeValue(this.selected);
    this.activateDropdown();
  }

  isSelected(index) {
    return this.selected === this.options[index];
  }
}
